import type { PipelineStage } from "@/schema/brand-os/brand-governance";

export const mContentPipelineStages: PipelineStage[] = [
  { id: "briefed", label: "Briefed", count: 12, barColor: "bg-gray-300 dark:bg-gray-600", legendColor: "bg-gray-400" },
  { id: "in_production", label: "In Production", count: 28, barColor: "bg-gray-400 dark:bg-gray-500", legendColor: "bg-gray-500" },
  { id: "in_review", label: "In Review", count: 9, barColor: "bg-amber-400 dark:bg-amber-500", legendColor: "bg-amber-500" },
  { id: "approved", label: "Approved", count: 45, barColor: "bg-green-500", legendColor: "bg-green-500" },
  { id: "rejected", label: "Rejected", count: 6, barColor: "bg-red-500", legendColor: "bg-red-500" },
];

export const mContentPipelineTotal = 100;

export const mDateRanges = [
  { value: "MTD", label: "MTD" },
  { value: "QTD", label: "QTD" },
  { value: "YTD", label: "YTD" },
  { value: "last_7d", label: "Last 7 days" },
  { value: "last_30d", label: "Last 30 days" },
  { value: "custom", label: "Custom" },
] as const;

export type dateRangeType = (typeof mDateRanges)[number]["value"];
